import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { toast, ToastContainer as ToastContainer$1, Slide } from 'react-toastify';
import { Body, Button } from '@cognite/cogs-core';
import { getStatusIcon } from '@cognite/cogs-icons';
import { IconWrapper } from '@cognite/cogs-utils';

var ToastContainer = function ToastContainer(_a) {
  var _a$autoClose = _a.autoClose,
    autoClose = _a$autoClose === undefined ? 5000 : _a$autoClose,
    _a$position = _a.position,
    position = _a$position === undefined ? toast.POSITION.BOTTOM_LEFT : _a$position,
    _a$limit = _a.limit,
    limit = _a$limit === undefined ? 1 : _a$limit,
    rest = __rest(_a, ["autoClose", "position", "limit"]);
  return jsx(ToastContainer$1, Object.assign({
    className: "cogs-lab cogs-toast-container",
    toastClassName: "cogs-toast",
    bodyClassName: "cogs-toast-body",
    autoClose: autoClose,
    newestOnTop: true,
    transition: Slide,
    position: position,
    limit: limit
  }, rest));
};
var AutoCloseDuration = {
  neutral: 4000,
  danger: 8000,
  warning: 6000,
  success: 4000
};
var ToastCogsWrapper = function ToastCogsWrapper(_a) {
  var body = _a.body,
    buttonText = _a.buttonText,
    onButtonClick = _a.onButtonClick,
    _a$type = _a.type,
    type = _a$type === undefined ? 'neutral' : _a$type,
    otherProps = __rest(_a, ["body", "buttonText", "onButtonClick", "type"]);
  var renderButton = function renderButton() {
    if (onButtonClick) {
      return jsx(Button, {
        onClick: onButtonClick,
        size: "small",
        inverted: true,
        type: "ghost",
        className: "cogs-toast__inner__button",
        children: buttonText
      });
    }
    return null;
  };
  // to remove unwanted prop coming from toastify
  var _b = otherProps;
    _b.toastProps;
    var props = __rest(_b, ["toastProps"]);
  var Icon = getStatusIcon(type);
  return jsxs("div", Object.assign({
    className: "cogs-toast__inner"
  }, props, {
    children: [jsx(IconWrapper, {
      size: 20,
      className: "cogs-toast__icon",
      children: Icon && jsx(Icon, {})
    }), jsx("div", {
      className: "cogs-toast__inner__content",
      children: jsx(Body, {
        className: "cogs-toast__inner__content__body",
        inverted: true,
        noOfLines: 2,
        children: body
      })
    }), renderButton()]
  }));
};
/**
 * Single function to open a toast
 * @param cogsOptions - main options required to display a toast properly.
 * @param toastOptions - additional options that expose react-toastify options.
 */
var makeToast = function makeToast(cogsOptions, toastOptions) {
  toast(jsx(ToastCogsWrapper, Object.assign({}, cogsOptions)), Object.assign(Object.assign({
    closeButton: false,
    hideProgressBar: true,
    autoClose: (toastOptions === null || toastOptions === undefined ? undefined : toastOptions.autoClose) || AutoCloseDuration[cogsOptions.type || 'neutral']
  }, toastOptions), {
    className: "cogs-toast-".concat(cogsOptions.type || 'neutral')
  }));
};

export { ToastContainer, makeToast };
